module.exports = __webpack_public_path__ + "31a4371cedf52b9e36f61e1528f96ffe.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-lily.png
// module id = 583
// module chunks = 30